import { useEffect } from "react"
import {
  usePostUserapiResultsGenerateRunLogMutation,
} from "../app/services/meseeknaApi"
import { useParams, useNavigate } from "react-router-dom"

const ThankYouComponent = () => {
  const { runId } = useParams()
  const navigate = useNavigate()

  const [postGenerateRunLogApi] = usePostUserapiResultsGenerateRunLogMutation()

  useEffect(() => {
    localStorage.removeItem("sim_status")
    const generateLogApiCall = async () => {
      if (runId) {
        await postGenerateRunLogApi({ body: { id: Number(runId) } })
      }
    }
    generateLogApiCall()
  }, [runId])

  const handleGoToDashboard = () => {
    navigate("/dashboard")
  }

  return (
    <div className="rounded-xl bg-base-white shadow-[0px_20px_24px_-4px_rgba(16,_24,_40,_0.08),_0px_8px_8px_-4px_rgba(16,_24,_40,_0.03)] w-[541px] overflow-hidden flex flex-col py-6 px-0 box-border items-center justify-start relative text-left text-base text-gray-700 font-text-md-regular">
      <div className="w-[512px] flex flex-row items-center justify-center z-[4] text-center text-gray-900">
        <div className="w-[352px] flex flex-col items-center justify-start gap-[24px]">
          <div className="self-stretch flex flex-col items-center justify-start gap-[16px]">
            <img
              className="relative rounded-9xl w-14 h-14 object-cover"
              alt=""
              src="/v3/assets/featured-icon15.svg"
            />
            <div className="self-stretch flex flex-col items-center justify-start gap-[4px]">
              <div className="self-stretch relative leading-[28px] font-semibold">
                Simulation Completed
              </div>
              <div className="self-stretch relative text-sm leading-[24px] text-gray-600">
                <p className="[margin-block-start:0] [margin-block-end:14px]">
                  Great job!
                </p>
                {process.env.REACT_APP_DEMO_MODE?.toLowerCase() ==
                  "true" && (
                  <p className="[margin-block-start:0] [margin-block-end:14px] font-semibold">
                    This simulation is designed for demonstration purposes
                    and therefore is ending now. Please contact the
                    Meseekna team if you have any questions.
                  </p>
                )}
                <p className="[margin-block-start:0] [margin-block-end:14px]">
                  Your simulation data has been saved. You may exit the
                  browser now. Thank you so much for your participation.
                </p>

                <p className="m-0">Thank you for your participation!</p>
              </div>
            </div>
          </div>

          <div
            onClick={handleGoToDashboard}
            className="rounded-lg bg-blue-light-600 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] overflow-hidden flex flex-row py-2.5 px-[18px] items-center justify-center gap-[8px] text-base-white border-[1px] border-solid border-blue-light-600 cursor-pointer">
            <div className="relative leading-[28px] font-semibold">
              Go to Dashboard
            </div>
          </div>
        </div>
      </div>

      <img
        className="absolute my-0 mx-[!important] top-[0px] left-[0.5px] w-[541px] h-[362px] object-contain object-top z-[2]"
        alt=""
        src="/v3/assets/confetti@2x.png"
      />
    </div>
  )
}

export default ThankYouComponent
